import { Center, Text } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import LazyBox from '../lazy/LazyBox'

interface BlankStateProps {
  image?: string
  icon?: ReactNode
  title: string
  description: string
}

const BlankState = ({ image, icon, title, description }: BlankStateProps) => {
  return (
    <Center w="100%" flexDir="column" gap="12px">
      {icon ? (
        <Center width="240px" height="160px" bg="#F6F8FB" borderRadius="8px" color="#7E8B9A" aria-hidden="true">
          {icon}
        </Center>
      ) : (
        <LazyBox width={240} height={160} src={image ?? 'https://placehold.co/382x254'} />
      )}
      <Text fontWeight="500" fontSize="22px">
        {title}
      </Text>
      <Text fontWeight="400" fontSize="15px" color="#7E8B9A">
        {description}
      </Text>
    </Center>
  )
}

export default BlankState
